﻿import { LiveDataSet, Status } from "../../API/LiveData/LiveDataSet";
import { IStationValueFormatter, IStationValueObject, WarningThreshold } from "../../Formatters/IStationValueFormatter";
import { ILiveDataListener, ILiveDataListenerContext } from "../../ILiveDataListener";
import { PopupChartable } from "../../PopupChartable";
import { ISiteObservationsPage } from "./ISiteObservationsPage";

export class ValueSpan extends PopupChartable implements ILiveDataListener {
    private span: JQuery;

    constructor(page: ISiteObservationsPage, container: JQuery, valueFormatter: IStationValueFormatter,
        ctx: ILiveDataListenerContext) {

        super(page.mainSite);

        this.valueFormatter = valueFormatter;
        this.station = page.station.Station;
        this.warningGroup = page.warningGroup;

        if (valueFormatter.plottable()) {

            container.attr('title', 'Click for parameter popup')
                .click((e: JQueryMouseEventObject) => {
                    this.renderPopup(e);
                });
        }

        this.span = $('<span></span>').appendTo(container);
            
        if (page.mainSite.liveDataManager.latestData) {
            this.liveDataChanged(page.mainSite.liveDataManager.latestData, ctx);
        }
    }

    public liveDataChanged(latestData: LiveDataSet, ctx: ILiveDataListenerContext): void {
        var valueObject: IStationValueObject = this.valueFormatter.format(latestData.Stations[this.station.Id], this.warningGroup);

        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);
        this.span.attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.')

        ctx.valueChanged(valueObject);

        this.span.text(valueObject.Value); // valueObject handles the formatting
        if (valueObject.Status === null || valueObject.Status === Status.Expired) {

            // no valid data -> hide units and remove any colour coding
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_3');

            this.span.addClass('midi_siteObsPage_expiring');

            return;
        }

        if (valueObject.Status == Status.Good) {
            this.span.removeClass('midi_siteObsPage_expiring');
        } else {
            this.span.addClass('midi_siteObsPage_expiring');
        }

        // by this point we will be showing some data

        if (valueObject.WarningThreshold == WarningThreshold.Level3) {
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.span.addClass('midi_siteObsPage_exceeded_threshold_3');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level2) {
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.span.addClass('midi_siteObsPage_exceeded_threshold_2');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level1) {
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.span.addClass('midi_siteObsPage_exceeded_threshold_1');
        } else {
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_3');
        }
    }
}